import { LegalPage } from '#app/components/legal-page.tsx'
import { type Route } from './+types/imprint.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Impressum · Kuratier' },
]

export default function ImprintRoute() {
	return (
		<LegalPage title="Impressum" updated="04.08.2026">
			<section>
				<h2>Angaben gemäß § 5 DDG</h2>
				<p>
					<strong>dataso GmbH</strong>
					<br />
					Tilsiter Str. 1<br />
					64342 Seeheim-Jugenheim
				</p>
				<p>
					<strong>Vertreten durch den Geschäftsführer:</strong> Dawid Sochacki
				</p>
				<p>
					<strong>Kontakt:</strong>
					<br />
					E-Mail: <a href="mailto:dawid@dataso.de">dawid@dataso.de</a>
				</p>
				<p>
					<strong>Registereintrag:</strong>
					<br />
					Eingetragen im Handelsregister des Amtsgerichts Darmstadt
					<br />
					Registernummer: HRB 103733
				</p>
				<p>
					<strong>Umsatzsteuer-Identifikationsnummer</strong> gemäß § 27a UStG:
					DE355595172
				</p>
				<p>
					<strong>Inhaltlich verantwortlich</strong> gemäß § 18 Abs. 2 MStV:
					<br />
					Dawid Sochacki, Anschrift wie oben
				</p>
			</section>

			<section>
				<h2>Verbraucherstreitbeilegung</h2>
				<p>
					Wir sind nicht bereit und nicht verpflichtet, an
					Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
					teilzunehmen.
				</p>
			</section>

			<section>
				<h2>Hinweis zu Inhalten</h2>
				<p>
					Kuratier speichert, hostet und verbreitet keine audiovisuellen
					Inhalte. Die Plattform organisiert vom Nutzer selbst eingebrachte
					Quellen und ergänzt frei verfügbare Metadaten (u. a. TMDB, OMDb) sowie
					Verfügbarkeitsinformationen (JustWatch). Für die Rechtmäßigkeit der
					von Nutzern eingebundenen Quellen sind ausschließlich die Nutzer
					verantwortlich; auf begründete Hinweise handeln wir nach dem in den{' '}
					<a href="/terms">Nutzungsbedingungen</a> (Ziffer 6) beschriebenen
					Meldeverfahren.
				</p>
			</section>
		</LegalPage>
	)
}
